export default [
  "ResizeObserver loop limit exceeded",
  "TypeError: a[b].target.className.indexOf is not a function",
  "ReferenceError: 'Promise' is undefined",
  "Loading chunk",
  "Can't find variable: instantSearchSDKJSBridgeClearHighlight",
  "this.videoRecognizer.flipCamera",
];
